import { useEffect, useMemo, useState } from 'react';
import { createIntl, createIntlCache } from 'react-intl';
import { defaultTranslation } from '../../sources';
import { DEFAULT_LOCALE } from '../../constants';
import { loadTranslations } from '../../helpers';
import { useExtendedFormatMessage } from '../useExtendedFormatMessage';
const cache = createIntlCache();
const createIntlInstance = (locale, messages) => {
    return createIntl({
        locale,
        messages,
    }, cache);
};
/**
 * A hook that provides an intl object for selected locale.
 * This intl is separate from one used by the `IntlProvider` component.
 * @returns The intl for selected locale.
 */
export const useSelectedLocaleIntl = (locale) => {
    const [intl, setIntl] = useState(createIntlInstance(DEFAULT_LOCALE, defaultTranslation));
    useEffect(() => {
        const updateIntl = async () => {
            const translations = await loadTranslations(locale);
            setIntl(createIntlInstance(locale, translations.messages));
        };
        void updateIntl();
    }, [locale]);
    const formatMessage = useExtendedFormatMessage(intl);
    const extendedIntl = useMemo(() => ({ ...intl, formatMessage }), [intl]);
    return extendedIntl;
};
//# sourceMappingURL=useSelectedLocaleIntl.js.map